import { Trophy, Users, Coffee, Ship, MessageSquare } from "lucide-react";

interface ClanCardProps {
  title: string;
  description: string;
  leftIcon: "Trophy" | "Ship" | "Coffee";
  leftText: string;
  rightIcon: "Users" | "Trophy" | "MessageSquare";
  rightText: string;
}

const ClanCard = ({ title, description, leftIcon, leftText, rightIcon, rightText }: ClanCardProps) => {
  const getIcon = (iconName: string, className: string) => {
    const icons = {
      Trophy: <Trophy className={className} />,
      Users: <Users className={className} />,
      Coffee: <Coffee className={className} />,
      Ship: <Ship className={className} />,
      MessageSquare: <MessageSquare className={className} />
    };
    return icons[iconName as keyof typeof icons];
  };

  return (
    <div className="clan-card">
      <h3 className="font-serif font-bold text-2xl mb-4 text-sunset">{title}</h3>
      <p className="text-gray-300 mb-4">{description}</p>
      <div className="flex items-center justify-between text-sm">
        <span className="text-ocean">
          {getIcon(leftIcon, "w-4 h-4 inline-block mr-1")}
          {leftText}
        </span>
        <span className="text-sunset">
          {getIcon(rightIcon, "w-4 h-4 inline-block mr-1")}
          {rightText}
        </span>
      </div>
    </div>
  );
};

export default ClanCard;